import { useRouteActive } from "@/context/SitePageVisibilityContext";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

/**
 * Wraps a public page. Blocks direct URL access ONLY when the page's
 * `page_active` flag is off — hiding a page from the header/footer alone
 * still keeps the direct URL usable (spec: unlisted pages).
 */
export function PageGate({ pageKey, children }) {
  const active = useRouteActive(pageKey);
  if (active) return children;
  return <HiddenPagePlaceholder />;
}

export function HiddenPagePlaceholder() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm" data-testid="hidden-page-placeholder">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#101876]/5 text-[#101876]">
          <Lock className="h-5 w-5" />
        </div>
        <h1 className="mt-4 text-xl font-bold text-slate-900">Page unavailable</h1>
        <p className="mt-2 text-sm text-slate-500">
          This page is currently unavailable. Please check back later or return to the homepage.
        </p>
        <Link to="/" className="mt-6 inline-block rounded-xl bg-[#101876] px-5 py-2 text-sm font-semibold text-white hover:bg-[#0c135c]">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
